import { useRecoilState } from 'recoil';

import { TabState } from 'src/recoils/tabIndex';

export function useCurrentTab() {
  const [currentTab, setCurrentTab] = useRecoilState(TabState);

  return { currentTab, setCurrentTab };
}
